import React from 'react';
import './Analyzer.css';

const ThankYouApp = () => {
    return (
        <div >Thank You Moneywide APP</div>
    )
}

export default ThankYouApp;